module.exports = __webpack_public_path__ + "static/media/business-01.868b5c57.png";